"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUNDUP = void 0;
exports.ROUNDUP = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:ROUNDUP not implemented');
    },
};
//# sourceMappingURL=roundup.js.map